module.exports = __webpack_public_path__ + "img/02572512000158.d89dbe87.png";